function ProjectMeta({ role, timeline, tools }) {
  // Convert role and tools to arrays if they're strings
  const roleArray = role ? (Array.isArray(role) ? role : [role]) : [];
  const toolsArray = tools ? (Array.isArray(tools) ? tools : tools.split(',').map(t => t.trim())) : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-16 text-center md:text-left">
      {roleArray.length > 0 && (
        <div>
          <h3 className="text-lg font-medium text-[#0D0D0D] mb-2">Role</h3>
          <div className="flex flex-wrap gap-1.5 justify-center md:justify-start">
            {roleArray.map((roleItem, index) => (
              <span
                key={index}
                className="inline-block px-2.5 py-1 text-sm font-normal rounded bg-[#F5F5F5] text-[#666666]"
              >
                {roleItem}
              </span>
            ))}
          </div>
        </div>
      )}
      {timeline && (
        <div>
          <h3 className="text-lg font-medium text-[#0D0D0D] mb-2">Timeline</h3>
          <p className="text-base text-[#999999] font-normal">{timeline}</p>
        </div>
      )}
      {toolsArray.length > 0 && (
        <div>
          <h3 className="text-lg font-medium text-[#0D0D0D] mb-2">Tools</h3>
          <div className="flex flex-wrap gap-1.5 justify-center md:justify-start">
            {toolsArray.map((tool, index) => (
              <span
                key={index}
                className="inline-block px-2.5 py-1 text-sm font-normal rounded bg-[#F5F5F5] text-[#666666]"
              >
                {tool}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectMeta;

